import { QUESTIONNAIRE_ANSWER_TYPES } from './questionnaire.enums';

const LANGUAGE_PROFICIENCY = ['Basic', 'Intermediate', 'Fluent'];

export const SCHOOL_LEAVERS_QUESTIONS = [
  {
    key: 'Q1',
    number: 1,
    question:
      'Are you currently pursuing further studies as a full-time student in a higher educational institute?',
    type: QUESTIONNAIRE_ANSWER_TYPES.BOOLEAN,
    is_required: true,
  },
  {
    key: 'Q2',
    number: 2,
    question: 'If yes, what is your study schedule?',
    type: QUESTIONNAIRE_ANSWER_TYPES.RADIO,
    options: ['Weekdays', 'Weekends'],
    is_required: true,
    depends_on: { key: 'Q1', value: true },
  },
  {
    key: 'Q3',
    number: 3,
    question: 'What is your aspirational monthly income?',
    type: QUESTIONNAIRE_ANSWER_TYPES.NUMBER,
    placeholder: 'Enter amount (LKR)',
    is_required: true,
  },
  {
    key: 'Q4',
    number: 4,
    question:
      'Are you committed to working with monthly targets to achieve your aspirational income?',
    type: QUESTIONNAIRE_ANSWER_TYPES.BOOLEAN,
    is_required: true,
  },
  {
    key: 'Q5',
    number: 5,
    question:
      'Are you committed to working on holidays, weekends, or late hours to achieve your aspired monthly income?',
    type: QUESTIONNAIRE_ANSWER_TYPES.BOOLEAN,
    is_required: true,
  },
  {
    key: 'Q6',
    number: 6,
    question: 'What are your career goals for the next 3 years?',
    type: QUESTIONNAIRE_ANSWER_TYPES.TEXTAREA,
    remarks:
      'Please specify your goals related to Income, Personal development & Education',
    is_required: true,
  },
  {
    key: 'Q7',
    number: 7,
    question: 'Do you have any dependents?',
    type: QUESTIONNAIRE_ANSWER_TYPES.BOOLEAN,
    is_required: true,
  },
  {
    key: 'Q8',
    number: 8,
    question: 'Do you have experience in any of the following areas?',
    type: QUESTIONNAIRE_ANSWER_TYPES.MULTI_SELECT,
    options: [
      'Customer Handling',
      'Membership of Social Clubs/Associations',
      'Handling Community Projects',
      'None',
    ],
    is_required: true,
  },
  {
    key: 'Q9',
    number: 9,
    question: 'Language Proficiency (Read and Write) – Sinhala',
    type: QUESTIONNAIRE_ANSWER_TYPES.RADIO,
    options: LANGUAGE_PROFICIENCY,
    is_required: true,
  },
  {
    key: 'Q10',
    number: 10,
    question: 'Language Proficiency (Read and Write) – Tamil',
    type: QUESTIONNAIRE_ANSWER_TYPES.RADIO,
    options: LANGUAGE_PROFICIENCY,
    is_required: true,
  },
  {
    key: 'Q11',
    number: 11,
    question: 'Language Proficiency (Read and Write) – English',
    type: QUESTIONNAIRE_ANSWER_TYPES.RADIO,
    options: LANGUAGE_PROFICIENCY,
    is_required: true,
  },
  {
    key: 'Q12',
    number: 12,
    question: 'Rate your proficiency in MS Word / MS Excel',
    type: QUESTIONNAIRE_ANSWER_TYPES.RATING,
    scale_max: 5,
    is_required: true,
  },
  {
    key: 'Q13',
    number: 13,
    question:
      'Do you have financial support during the initial period of 3 months?',
    type: QUESTIONNAIRE_ANSWER_TYPES.RADIO,
    options: ['Yes', 'Partial', 'No'],
    is_required: true,
  },
  {
    key: 'Q14',
    number: 14,
    question: 'How would you rate your monthly financial commitments?',
    type: QUESTIONNAIRE_ANSWER_TYPES.RADIO,
    options: ['Low', 'Medium', 'High', 'Very High'],
    is_required: true,
  },
  {
    key: 'Q15',
    number: 15,
    question:
      'Are you committed to pursuing a career in Insurance Advisership with unlimited earning potential?',
    type: QUESTIONNAIRE_ANSWER_TYPES.BOOLEAN,
    is_required: true,
  },
];
